import { Locale } from '@ps-smart-cp/ppfw-client';

const assetStateClassNameConfig = {
  normal: new Map([
    [Locale.ja, '通常'],
    [Locale.en, 'Normal'],
  ]),
  retired: new Map([
    [Locale.ja, '除却済'],
    [Locale.en, 'Retired'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { assetStateClassNameConfig };
